import React from 'react';
import cx from 'classnames';
import CardContent from './card-content';
enum CardType {
    NONE = 'NONE',
    FILLED = 'FILLED',
    STROKE = 'STROKE',
}

const mapThemeToClassname = {
    [CardType.NONE]: '',
    [CardType.FILLED]: 'card--filled',
    [CardType.STROKE]: 'card--stroke',
};

export type CardPropsType = {
    key?: string;
    imageUrl?: string;
    url?: string;
    title?: string;
    text?: string;
    backgroundColor?: string;
    type?: CardType;
    hasHover?: boolean;
    hasNoBottomPadding?: boolean;
    tag?: 'li' | 'div';
    fixedSize?: boolean;
};

const Card: React.FC<React.PropsWithChildren<CardPropsType>> & {
    Type: typeof CardType;
} = ({
    key,
    imageUrl,
    url,
    title,
    text,
    backgroundColor,
    children,
    type = CardType.NONE,
    hasHover = true,
    hasNoBottomPadding,
    tag = 'li',
    fixedSize,
}) => {
    const content = children || (
        <CardContent title={title} text={text} imageUrl={imageUrl} url={url} />
    );

    const classnames = cx({
        card: true,
        'card--fixed-size': fixedSize,
        [mapThemeToClassname[type]]: true,
        'has-hover': hasHover,
        'has-no-bottom-padding': hasNoBottomPadding,
    });

    const Tag = tag;

    return (
        // @ts-ignore
        // eslint-disable-next-line react/forbid-component-props
        <Tag className={classnames} key={key} style={{ backgroundColor }}>
            {content}
        </Tag>
    );
};

Card.Type = CardType;

export default Card;
